import {validation} from './validation';

export default class LengthValidation {
  constructor(input) {
    const min = (input.minLength && parseInt(input.minLength) > 0) ? parseInt(input.minLength) : -1;
    const max = (input.maxLength && parseInt(input.maxLength) > 0) ? parseInt(input.maxLength) : -1;
    this.test = validation.create((c) => (
      (min >= 0) ? c.length >= min : true
    ) && (
        (max >= 0) ? c.length <= max : true
      )
    ).test;
  }
}
